export default "__VITE_ASSET__uMhajtXY4E0NFYZE2c8qiw__"